import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useMemo } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BasicUserName from '../../../User/BasicUserName';
import UserAvatar from '../../../User/Avatar';
import PinIcon from '@wix/da-ds/pkg/Icons/24x24/Pin';
import GraduationCap from '@wix/da-ds/pkg/Icons/16x16/GraduationCap';
import { grouphubId } from '../../redux/constants';
import Flex from '@wix/da-ds/pkg/Flex';
import { BiData } from '@wix/da-bi/pkg/events';
import { ResourceType } from '../../../types/resource';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NetworkBarItem from '../NetworkBarItem';
import s from './NetworkBarGroupLink.scss';
const NetworkBarGroupLink = ({ group, isSelected, isCollapsed = false, tabIndex, rank, togglePinGroup, unrecommendGroup, className })=>{
    var _group_networkbar, _group_networkbar1, _group_networkbar2, _group_extendedGroup, _group_networkbar3, _group_networkbar4, _group_networkbar5, _group_networkbar6;
    const { t } = useTranslation();
    const isGroupHub = group.userId === grouphubId;
    const menuItems = useMemo(()=>{
        var _group_networkbar, _group_networkbar1, _group_extendedGroup;
        const menuItemBi = BiData({
            evid: 163,
            itemid: group.userId,
            typeid: ResourceType.GROUP,
            indicator: ((_group_networkbar = group.networkbar) === null || _group_networkbar === void 0 ? void 0 : _group_networkbar.hasNewContent) ? 1 : 0,
            rank
        });
        return [
            group.isWatching && !isGroupHub && (((_group_networkbar1 = group.networkbar) === null || _group_networkbar1 === void 0 ? void 0 : _group_networkbar1.isPinned) ? {
                label: t('networkBar.groups.group.actions.unpin'),
                onClick: ()=>togglePinGroup(group.userId, false),
                biData: _object_spread_props(_object_spread({}, menuItemBi), {
                    menu_item: 'unpin'
                })
            } : {
                label: t('networkBar.groups.group.actions.pin'),
                onClick: ()=>togglePinGroup(group.userId, true),
                biData: _object_spread_props(_object_spread({}, menuItemBi), {
                    menu_item: 'pin'
                })
            }),
            ((_group_extendedGroup = group.extendedGroup) === null || _group_extendedGroup === void 0 ? void 0 : _group_extendedGroup.isAdmin) && {
                label: t('networkBar.groups.group.actions.notifications'),
                link: Url.groupNotificationsLink(group.userId),
                biData: BiData({
                    evid: 165,
                    typeid: ResourceType.GROUP,
                    itemid: group.userId,
                    groupid: group.useridUuid,
                    sectionname: 'menu'
                })
            },
            {
                label: t('networkBar.groups.group.actions.visit'),
                link: Url.userLink(group.username),
                biData: BiData({
                    evid: 101,
                    itemid: group.userId,
                    typeid: ResourceType.GROUP,
                    sectionname: 'sidebar'
                })
            },
            !group.isWatching && !isGroupHub && {
                label: t('networkBar.groups.group.actions.unrecommend'),
                onClick: ()=>unrecommendGroup(group.userId),
                biData: _object_spread_props(_object_spread({}, menuItemBi), {
                    menu_item: 'unrecommend'
                })
            }
        ];
    }, [
        group.isWatching,
        group.networkbar,
        group.userId,
        group.useridUuid,
        group.username,
        group.extendedGroup,
        rank,
        t,
        togglePinGroup,
        unrecommendGroup,
        isGroupHub
    ]);
    // custom group icon for GroupHub
    const groupAvatarUser = isGroupHub ? _object_spread_props(_object_spread({}, group), {
        usericon: 'https://st.deviantart.net/eclipse/global/svg/grouphub.svg?1'
    }) : group;
    const PinIconComponent = isGroupHub ? GraduationCap : PinIcon;
    const url = isGroupHub ? Url.userLink(group.username) : ((_group_networkbar = group.networkbar) === null || _group_networkbar === void 0 ? void 0 : _group_networkbar.url) || Url.browseGroupFeedLink(group.username);
    return /*#__PURE__*/ React.createElement(NetworkBarItem, {
        url: url,
        icon: /*#__PURE__*/ React.createElement(UserAvatar, {
            user: groupAvatarUser,
            size: 24,
            className: classnames(isGroupHub && s['grouphub']),
            avatarClassName: classnames(isGroupHub && s['grouphub-avatar']),
            withLink: false
        }),
        tooltipContent: /*#__PURE__*/ React.createElement(Flex, {
            alignItems: "center"
        }, group.username, ((_group_networkbar1 = group.networkbar) === null || _group_networkbar1 === void 0 ? void 0 : _group_networkbar1.isPinned) && /*#__PURE__*/ React.createElement(PinIconComponent, {
            size: IconSize.TINY,
            disableDefaultColors: true,
            className: s['pin-icon']
        })),
        className: classnames(s['root'], isCollapsed && s['collapsed'], isSelected && s['selected'], className),
        linkClassName: classnames(s['group-link'], (((_group_networkbar2 = group.networkbar) === null || _group_networkbar2 === void 0 ? void 0 : _group_networkbar2.isPinned) || ((_group_extendedGroup = group.extendedGroup) === null || _group_extendedGroup === void 0 ? void 0 : _group_extendedGroup.isAdmin)) && s['has-pin']),
        menuClassName: s['actions'],
        iconClassName: s['avatar'],
        isCollapsed: isCollapsed,
        isSelected: isSelected,
        hasNewContent: (_group_networkbar3 = group.networkbar) === null || _group_networkbar3 === void 0 ? void 0 : _group_networkbar3.hasNewContent,
        tabIndex: tabIndex,
        menuItems: menuItems,
        biData: BiData({
            evid: 160,
            itemid: group.userId,
            typeid: ResourceType.GROUP,
            indicator: ((_group_networkbar4 = group.networkbar) === null || _group_networkbar4 === void 0 ? void 0 : _group_networkbar4.hasNewContent) ? 1 : 0,
            rank,
            is_expanded: isCollapsed ? 0 : 1
        }),
        menuBiData: BiData({
            evid: 162,
            itemid: group.userId,
            typeid: ResourceType.GROUP,
            indicator: ((_group_networkbar5 = group.networkbar) === null || _group_networkbar5 === void 0 ? void 0 : _group_networkbar5.hasNewContent) ? 1 : 0,
            rank
        })
    }, ((_group_networkbar6 = group.networkbar) === null || _group_networkbar6 === void 0 ? void 0 : _group_networkbar6.isPinned) && /*#__PURE__*/ React.createElement(PinIconComponent, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['username']
    }, /*#__PURE__*/ React.createElement(BasicUserName, {
        user: group,
        showSymbol: false
    })));
};
NetworkBarGroupLink.displayName = 'NetworkBarGroupLink';
export default NetworkBarGroupLink;
